import EventBus from './event-bus';
import { EVENTS } from '../services/constants';
import UrlService from '../services/url-service'

angular.module('eatself').factory('UibmodalService', function($uibModal, $state) {
	init();

    function init() {
		console.log('uibmodal-service init!');
        EventBus.$on(EVENTS.modal.editOptionGroups, (optionGroup) => editOptionGroups(optionGroup));
    }

    function editOptionGroups(optionGroup) {
		// UrlService.go({name: 'admin2.profile.option-groups', params: { optionGroup} });
		// return;
		let template = '<option-groups-modal modal="vm.modal" option-group="vm.optionGroup"></option-groups-modal>';
		if ($state.includes('admin1')) {
			template = '<option-groups-modal1 modal="vm.modal" option-group="vm.optionGroup"></option-groups-modal1>';
		}
		return $uibModal.open({
			windowClass: "optionGroupsModal modalMobileFull centered scs-scroller",
			template: template,
			controllerAs: 'vm',
			controller: function($uibModalInstance) {
				this.modal = $uibModalInstance;
				this.optionGroup = optionGroup;
			},
			backdrop: 'static',
			size: 'md',
		});
	}
    return {};
})